export function listHandler (list, i18nPath) {
  // 结合语言版本进行初始化数据
  const listByLanguage = this.$t(i18nPath)
  return list.map((item, index) => {
    return {
      ...item,
      ...listByLanguage[index],
    }
  })
}
